<template>
    <div class="move-opportunity-flow-process">
        <GoalModal
            data-qa="move-opportunity-flow-process"
            :is-open="isOpen"
            :title="$t('funnel.edit.sideBar.process.moveOpportunity.title')"
            :summary-text="$t('funnel.edit.sideBar.process.moveOpportunity.summary')"
            @update-config="saveCell"
            @close-modal="closeModal"
        >
            <template #goalParameters>
                <DsMultiselect
                    v-model="stageValue"
                    data-qa="move-opportunity-flow-process-stage"
                    :force-invalid="!Number.isInteger(stageValue)"
                    :placeholder="$t('funnel.edit.sideBar.process.moveOpportunity.stage.placeholder')"
                    :options="stageOptions"
                    searchable
                    help-text
                    pin-bottom
                    bind-value-only
                >
                    <template #help>
                        <span v-if="!Number.isInteger(stageValue)">
                            {{ $t('funnel.edit.sideBar.process.moveOpportunity.validation.required') }}
                        </span>
                    </template>
                </DsMultiselect>
                <DsMultiselect
                    v-model="opportunityCriteriaValue"
                    data-qa="move-opportunity-flow-process-criteria"
                    :placeholder="$t('funnel.edit.sideBar.process.moveOpportunity.criteria.placeholder')"
                    :options="opportunityCriteriaOptions"
                    searchable
                    help-text
                    pin-bottom
                    bind-value-only
                />
                <DsCheckbox
                    v-model="isIgnoreWonLost"
                    data-qa="move-opportunity-flow-process-checkbox"
                    :label="$t('funnel.edit.sideBar.process.moveOpportunity.checkbox.placeholder')"
                />
                <div class="move-opportunity-warning">
                    <div class="move-opportunity-warning-icon">
                        <DsIcon name="alert-triangle" />
                    </div>

                    <div class="move-opportunity-warning-text">
                        {{ $t('funnel.edit.sideBar.process.moveOpportunity.warning1') }}
                        <br /><br />
                        {{ $t('funnel.edit.sideBar.process.moveOpportunity.warning2') }}
                    </div>
                </div>
            </template>
        </GoalModal>
    </div>
</template>
<script>
import { PROCESS_MOVE_OPPORTUNITY } from '../../../../utils/editor.constants';
import GoalModal from '../../../whens/goalModal/GoalModal.vue';
import { loadStages } from '../../../whens/opportunityStageMoved/opportunity.stage.moved.api';

const OPPORTUNITY_VALUES = {
    RECENTLY_CREATED: 'recentlyCreated',
    RECENTLY_UPDATED: 'recentlyUpdated',
    ALL: 'all',
};

export default {
    components: {
        GoalModal,
    },
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        cell: {
            type: Object,
            default: () => ({
                value: {
                    stageToMove: null,
                    configOption: null,
                    ignoreWonLost: 1,
                },
            }),
        },
    },
    emits: ['close-modal', 'update-cell-value'],
    data () {
        return {
            cellType: PROCESS_MOVE_OPPORTUNITY,
            saveCellOptions: {},
            ignoreWonLost: 1,
            stageValue: undefined,
            opportunityCriteriaValue: OPPORTUNITY_VALUES.RECENTLY_CREATED,
            stageOptions: [],
            opportunityCriteriaOptions: [
                {
                    label: this.$t('funnel.edit.sideBar.process.moveOpportunity.criteria.created'),
                    value: OPPORTUNITY_VALUES.RECENTLY_CREATED,
                },
                {
                    label: this.$t('funnel.edit.sideBar.process.moveOpportunity.criteria.updated'),
                    value: OPPORTUNITY_VALUES.RECENTLY_UPDATED,
                },
                {
                    label: this.$t('funnel.edit.sideBar.process.moveOpportunity.criteria.all'),
                    value: OPPORTUNITY_VALUES.ALL,
                },
            ],
        };
    },
    computed: {
        isIgnoreWonLost: {
            get() {
                return !!this.ignoreWonLost;
            },
            set(value) {
                this.ignoreWonLost = value ? 1 : 0;
            },
        },
    },
    mounted () {
        this.loadConfig();
    },
    methods: {
        async loadConfig () {
            try {
                await this.loadDropdowns();
                this.loadCellValue();
            } catch (error) {
                this.$error({ message: this.$t('funnel.edit.sideBar.process.moveOpportunity.error.loading') });
            }
        },
        loadCellValue() {
            const cell = { ...this.cell };

            cell.value = cell.value || {};

            this.opportunityCriteriaValue = cell.value.configOption;
            this.ignoreWonLost = cell.value.ignoreWonLost === 1 ? 1 : 0;
            this.stageValue = parseInt(cell.value.stageToMove || 0, 10);

            if (!this.opportunityCriteriaValue) {
                const [firstElement] = this.opportunityCriteriaOptions;

                this.opportunityCriteriaValue = firstElement.value;
            }

            if (!this.stageValue && this.stageOptions?.length > 0) {
                const [firstElement] = this.stageOptions;

                this.stageValue = firstElement.value;
            }

            if (cell.value.ignoreWonLost === undefined) {
                this.ignoreWonLost = 1;
            }
        },
        async loadDropdowns() {
            this.stageOptions = await loadStages();
        },
        saveCell () {
            const cell = { ...this.cell };

            cell.value = cell.value || {};

            if (Number.isInteger(this.stageValue)) {
                cell.value.stageToMove = `${this.stageValue}L`;
                cell.value.configOption = this.opportunityCriteriaValue;
                cell.value.ignoreWonLost = this.ignoreWonLost ? 1 : 0;

                this.$emit('update-cell-value', { cell });
            }
        },
        closeModal () {
            this.$emit('close-modal', PROCESS_MOVE_OPPORTUNITY);
        },
    },
};
</script>

<style lang="scss" scoped>
.move-opportunity-warning {
    display:            flex;
    padding:            px-to-rem(12);
    border-radius:      px-to-rem(8);
    flex-wrap:          wrap;
    justify-items:      left;
    background-color:   $color-yellow-050;
}

.move-opportunity-warning {
    flex:   6%;
    color:  $color-orange-300;
}

.move-opportunity-warning-text {
    margin-top: px-to-rem(2);
    margin-left: px-to-rem(8);
    flex:   94%;
    color:  $color-ink-900;
}
</style>
